import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRuntimeReporter } from "@plerity/runtime-reporter";

// Production runtime-error reporter — captures window.error + unhandledrejection
// and POSTs to /api/observability/errors. Disabled in dev.
initRuntimeReporter({
  app: "sms",
  disabled: import.meta.env.MODE !== "production",
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "dev",
});

// Force Zod jitless under strict CSP — Zod v4's JIT probes `new Function("")`
// on first parse; the dashboards' CSP blocks it (caught, harmless) but the
// browser fires a securitypolicyviolation that floods the RUM pipeline
// (~2,800 `CSP: script-src blocked eval` occurrences as of 2026-07-15).
// Mirrors @plerity/contracts src/zod-config.ts (separate zod instance).
import { z as _zodCspConfig } from "zod";
// Register the X-Tenant-Id interceptor on the shared dashboard apiClient so
// super-admin org switching affects shared-hook queries (not just local-client
// mutations). Invoked here once, before the first query fires.
import { registerSharedApiClientOrgInterceptor } from "./lib/admin";

_zodCspConfig.config({ jitless: true });

registerSharedApiClientOrgInterceptor();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in DOM");
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
